/* eslint-disable sort-keys */
export const urls: Record<
  'es',
  Record<string, '/l/es/es' | `/l/es/es/${string}`>
> = {
  es: {
    // Home
    '': '/l/es/es/home',

    // Alumni
    alumni: '/l/es/es/alumni',

    // B2B
    empresas: '/l/es/es/b2b',
    'empresas/contacto': '/l/es/es/b2b/apply',

    // Blog
    blog: '/l/es/es/blog',

    // Campus
    barcelona: '/l/es/es/campus/bcn',
    madrid: '/l/es/es/campus/mad',
    remoto: '/l/es/es/campus/rmt',

    // Career
    'apoyo-profesional': '/l/es/es/career',

    // Courses
    'desarrollo-web': '/l/es/es/course/wd',
    'data-analytics': '/l/es/es/course/da',
    'diseno-ux-ui': '/l/es/es/course/ux',
    ciberseguridad: '/l/es/es/course/cy',

    // FAQ
    'preguntas-frecuentes': '/l/es/es/faq',

    // Financing Options
    financiacion: '/l/es/es/financing',

    // Forms
    'solicitar-plaza': '/l/es/es/apply',
    'solicitar-plaza2': '/l/es/es/full-apply',
    contacto: '/l/es/es/contact',
    'formulario-financiacion': '/l/es/es/financing-form',
    gracias: '/l/es/es/thank-you',

    // Quiz
    quiz: '/l/es/es/quiz',
    'inteligencia-artificial/match': '/l/es/es/quiz-match/ai',
    'ciberseguridad/match': '/l/es/es/quiz-match/cy',
    'data-analytics/match': '/l/es/es/quiz-match/da',
    'devops-cloud-computing/match': '/l/es/es/quiz-match/dv',
    'marketing-digital/match': '/l/es/es/quiz-match/mk',
    'data-science-machine-learning/match': '/l/es/es/quiz-match/ml',
    'diseno-ux-ui/match': '/l/es/es/quiz-match/ux',
    'desarrollo-web/match': '/l/es/es/quiz-match/wd',

    // Syllabus Forms
    'consultor-ia/plan-de-estudios': '/l/es/es/syllabus/ac',
    'inteligencia-artificial/plan-de-estudios': '/l/es/es/syllabus/ai',
    'cloud-engineer/plan-de-estudios': '/l/es/es/syllabus/ce',
    'ciberseguridad/plan-de-estudios': '/l/es/es/syllabus/cy',
    'data-analytics/plan-de-estudios': '/l/es/es/syllabus/da',
    'data-engineering/plan-de-estudios': '/l/es/es/syllabus/de',
    'devops-cloud-computing/plan-de-estudios': '/l/es/es/syllabus/dv',
    'marketing-digital/plan-de-estudios': '/l/es/es/syllabus/mk',
    'data-science-machine-learning/plan-de-estudios': '/l/es/es/syllabus/ml',
    'product-manager-ia/plan-de-estudios': '/l/es/es/syllabus/pm',
    'diseno-ux-ui/plan-de-estudios': '/l/es/es/syllabus/ux',
    'desarrollo-web/plan-de-estudios': '/l/es/es/syllabus/wd',

    // PDP
    'consultor-ia/remoto': '/l/es/es/pdp/ac/rmt',
    'inteligencia-artificial/remoto': '/l/es/es/pdp/ai/rmt',
    'cloud-engineer/remoto': '/l/es/es/pdp/ce/rmt',
    'data-engineering/remoto': '/l/es/es/pdp/de/rmt',
    'devops-cloud-computing/remoto': '/l/es/es/pdp/dv/rmt',
    'marketing-digital/remoto': '/l/es/es/pdp/mk/rmt',
    'data-science-machine-learning/remoto': '/l/es/es/pdp/ml/rmt',
    'product-manager-ia/remoto': '/l/es/es/pdp/pm/rmt',
  },
};
/* eslint-enable sort-keys */
